module.exports = __webpack_public_path__ + "static/media/stBanner.d283e689.png";